import EmptyPage from '../../../components/empty-page/emptyPage';
import CommonTable from '../../../components/reusable-ui-components/commonTable/CommonTable';
import { getTotalSeatCount } from '../../../utils/getTotalSeatCount';

const SupBookingAct = ({ bookingData }) => {
    const columns = [
        {
            label: 'Activity Name',
            accessor: 'actId',
            render: (val) => val?.title || 'N/A'
        },
        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },

        {
            label: 'Date',
            accessor: 'startDate',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Time Slot',
            accessor: 'timeSlots',
            render: (val) => {
                if (!val) return '-';
                return `${val.startTime} - ${val.endTime}`;
            }
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val, row) => {
                const isReserved = Boolean(val?.isReserved);
                const isInstallment = Boolean(val?.isInstallment);

                if (!isReserved && !isInstallment) {
                    return <div style={{ textAlign: 'center' }}>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</div>;
                }

                const total = Number(val?.total) || 0;
                const paid = Number(val?.paid) || 0;

                const totalSeats = getTotalSeatCount(row?.totalSeats) || row?.userDetails?.length || 0;

                let balance = 0;
                let paymentText = '';

                // ---------------------------------------
                // RESERVED BOOKING
                // ---------------------------------------
                if (isReserved) {
                    // reserve is an ARRAY
                    const reservePerSeat = Number(val?.reserve?.[0]?.amount) || 0;

                    const reservedAmount = reservePerSeat * totalSeats;

                    balance = Math.max(0, total - reservedAmount);

                    paymentText = `(₹${reservePerSeat}/seat)`;
                }

                // ---------------------------------------
                // INSTALLMENT BOOKING
                // ---------------------------------------
                if (isInstallment) {
                    const installmentPaid = Array.isArray(val?.installments)
                        ? val.installments.reduce((sum, installment) => {
                              return sum + (Number(installment?.amount) || Number(installment?.total) || 0);
                          }, 0)
                        : 0;

                    balance = Math.max(0, total - installmentPaid);

                    paymentText = `(₹${installmentPaid})`;
                }

                return (
                    <div
                        style={{
                            color: 'red',
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                            verticalAlign: 'middle'
                        }}
                    >
                        {`${isReserved ? 'Reserved' : 'Installment'}\n${paymentText}
Total: ₹${total}
Paid: ₹${paid}
Balance: ₹${balance}`}
                    </div>
                );
            }
        },
        {
            label: 'Total Seats',
            accessor: 'totalSeats',
            render: (val) => {
                if (Array.isArray(val)) {
                    return val.map((seats, index) => (
                        <div key={index}>
                            {seats.name} - {seats.qty}
                        </div>
                    ));
                }

                return val ?? 0;
            }
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia'
        },
        // {
        //     label: 'People',
        //     accessor: 'userDetails',
        //     render: (val) => val?.length || 0
        // },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                // condition example
                // if (guStatus === 'Upcoming') {
                //     return row?.guStatus === 'Cancelled' ? (
                //         <span style={{ color: 'red', fontWeight: '600' }}>{row?.guStatus}</span>
                //     ) : (
                //         <span
                //             className='cancelTrip-btn'
                //             onClick={() => {
                //                 setShowModal(true);
                //                 setRowId(row._id);
                //             }}
                //         >
                //             Cancel
                //         </span>
                //     );
                // }

                return row.actStatus !== 'Cancelled' ? (
                    <span>{row?.actStatus}</span>
                ) : (
                    <span style={{ color: 'red', fontWeight: '600' }}>{row?.actStatus}</span>
                );
            }
        }
    ];
    return (
        <div>
            {bookingData && bookingData.length !== 0 ? (
                <CommonTable data={bookingData} columns={columns} />
            ) : (
                <EmptyPage />
            )}
        </div>
    );
};

export default SupBookingAct;
